import { ControlledSelectCheckmark } from 'Components/ControlledSelectCheckmark';
import { ICategory } from 'Context/CompassRightsContext/EntitlementsProvider';
import { SelectedCategory } from '..';
import { Avatar, SelectChangeEvent, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import React, { ReactNode } from 'react';
import { AccordionArrowPurpleClose } from 'Images';

interface ISelectCategory {
  categoryId: number;
  subCategories: ICategory[];
  width?: string;
  selected: SelectedCategory;
  onChange?: (categoryID: number, selected: string[]) => void;
  onChangeBypass?: (
    event: SelectChangeEvent<string[]>,
    child: ReactNode
  ) => void;
  label: string;
  icon?: string;
}
export const SelectCategory = ({
  categoryId,
  subCategories,
  width,
  selected,
  onChange = () => {},
  onChangeBypass,
  label,
  icon,
}: ISelectCategory) => {
  const isDesktop = useIsDesktop();
  const handleChangeSelected = (selected: string[]) => {
    onChange(categoryId, selected);
  };

  const selectedSubCategory =
    selected &&
    selected.subCategoryIds
      .map(
        (id) =>
          subCategories.find((subCategory: ICategory) => subCategory.id === id)!
      )
      .map((subCategory: ICategory) => subCategory.name);

  return (
    <ControlledSelectCheckmark
      closeIcon={AccordionArrowPurpleClose}
      size={'small'}
      options={[
        ...new Set(
          subCategories.map((subCategory: ICategory) => subCategory.name)
        ),
      ]}
      checkboxSx={{ paddingLeft: 0 }}
      menuPropsSx={
        isDesktop
          ? {
              mr: '25px',
            }
          : {
              '& .MuiPaper-root': {
                mr: '10px',
                width: 'calc(100% - 53px)',
              },
            }
      }
      selected={selectedSubCategory ?? new Array<string>()}
      onChange={
        !!onChangeBypass
          ? onChangeBypass
          : (e: SelectChangeEvent<string[]>, child: React.ReactNode) =>
              handleChangeSelected(e.target.value as string[])
      }
      width={width}
      displayEmpty={true}
      ariaLabel={label}
      startAdornment={
        icon ? (
          <Avatar
            src={icon}
            alt={''}
            sx={{ width: '30px', height: '30px', marginRight: '5px' }}
          />
        ) : null
      }
      renderValue={(selected) => (
        <Typography variant='body6'>{label}</Typography>
      )}
    />
  );
};
